import Nav from "./Nav";
import Footer from "./Footer";
import "./styles/application.css";
import { useState } from 'react';
import axios from "axios";
import { API_BASE_URL } from "../config";

export default function Application() {
    const [store, setStore] = useState([]);
    const [position, setPosition] = useState([]);
    const [availability, setAvailability] = useState([])
    const [name, setName] = useState("");
    const [address, setAddress] = useState("");
    const [city, setCity] = useState("");
    const [postcode, setPostcode] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [about, setAbout] = useState("");
    const [cv, setCv] = useState("");
    const [message, setMessage] = useState("")
    const [isSending, setIsSending] = useState(false);
    const [degreeStatus, setDegreeStatus] = useState("");
    const [degreeName, setDegreeName] = useState("");

    const send = async e => {
        e.preventDefault();
        setIsSending(true)
        setMessage("We are now sending your application. Please wait as this may take a couple of minutes.")
        const data = new FormData();
        var candidate = {
            store: store,
            position: position,
            availability: availability,
            name: name,
            address: address,
            city: city,
            postcode: postcode,
            email: email,
            phone: phone,
            about: about,
            education: {
              status: degreeStatus,
              name: degreeName,
            },
            cv: cv
        }
        const json = JSON.stringify(candidate);
        data.append('file', cv);
        data.append("candidate", json);
        await axios
            .post(`${API_BASE_URL}/tubbeesSite/apply`, data)
            .then(res => {
                setMessage("")
                alert("Application has been submitted")
                window.location.reload()
            }).catch(err => { 
              console.log(err); 
              setIsSending(false) 
            })
    }

    return (
      <>
        <Nav />
        <form onSubmit={send}>
        <section className="applicationPage">
          <div className="applicationForm">
            <h2>Apply to work with us</h2>
            <label>
              Preferred Store<span>*</span>:
            </label>
            <div className="multiSelectContainer">
              {[
                "RT Management Bearsden Ltd ",
                "Autoport",
                "Coatbridge",
                "Crowwood",
                "St James Rd",
                "Sauchiehall St",
                "Wishaw",
              ].map((storeName) => (
                <div key={storeName} className="multiSelectItem">
                  <label>
                    <input
                      type="checkbox"
                      required ={store.length === 0}
                      value={storeName}
                      checked={store.includes(storeName)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setStore([...store, storeName]);
                        } else {
                          setStore(store.filter((s) => s !== storeName));
                        }
                      }}
                    />{" "}
                    {storeName}
                  </label>
                </div>
              ))}
            </div>

            <label>
              Position<span>*</span>:
            </label>
            <div className="multiSelectContainer">
              {[
                "Dessert Lab Assistant",
                "Dessert Lab Supervisor",
                "Dessert Lab Manager",
              ].map((positionName) => (
                <div key={positionName} className="multiSelectItem">
                  <label>
                    <input
                      type="checkbox"
                      required={position.length === 0}
                      value={positionName}
                      checked={position.includes(positionName)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setPosition([...position, positionName]);
                        } else {
                          setPosition(
                            position.filter((p) => p !== positionName)
                          );
                        }
                      }}
                    />{" "}
                    {positionName}
                  </label>
                </div>
              ))}
            </div>
            <label>
              Availability<span>*</span>:
            </label>
            <div className="multiSelectContainer">
              {[
                "Full-time",
                "Part-time",
              ].map((availabilityName) => (
                <div key={availabilityName} className="multiSelectItem">
                  <label>
                    <input
                      type="checkbox"
                      required={availability.length === 0}
                      value={availabilityName}
                      checked={availability.includes(availabilityName)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setAvailability([...availability, availabilityName]);
                        } else {
                          setAvailability(
                            availability.filter((p) => p !== availabilityName)
                          );
                        }
                      }}
                    />{" "}
                    {availabilityName}
                  </label>
                </div>
              ))}
            </div>
            

            <label>
              Full Name<span>*</span>
            </label>
            <input
              type="text"
              required
              onChange={(e) => {
                setName(e.target.value);
              }}
              className="formInput"
            />
            <label>
              Full Address<span>*</span>
            </label>
            <input
              type="text"
              required
              onChange={(e) => {
                setAddress(e.target.value);
              }}
              className="formInput"
            />
            <label>
              Postcode<span>*</span>
            </label>
            <input
              type="text"
              required
              onChange={(e) => {
                setPostcode(e.target.value);
              }}
              className="formInput"
            />
            <label>
              City<span>*</span>
            </label>
            <input
              type="text"
              required
              onChange={(e) => {
                setCity(e.target.value);
              }}
              className="formInput"
            />
            <label>
              E-mail <span>*</span>
            </label>
            <input
              type="email"
              required
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              className="formInput"
            />
            <label>
              Phone <span>*</span>
            </label>
            <input
              type="number"
              required
              onChange={(e) => {
                setPhone(e.target.value);
              }}
              className="formInput"
            />
            <label>Education / Degree*</label>
              <select
                value={degreeStatus}
                onChange={(e) => setDegreeStatus(e.target.value)}
                required
              >
                <option value="">Select an option</option>
                <option value="N/A">Not applicable (N/A)</option>
                <option value="Studying">
                  Currently studying at university/college
                </option>
                <option value="Completed">Completed a degree</option>
              </select>
              {degreeStatus !== "N/A" && degreeStatus !== "" && (
                <>
                  <label>Degree name</label>
                  <input
                    type="text"
                    placeholder="e.g. BA Business, HND Accounting"
                    value={degreeName}
                    onChange={(e) => setDegreeName(e.target.value)}
                    required={degreeStatus !== "N/A" && degreeStatus !== ""}
                    className="formInput"
                  />
                </>
              )}
            <label>
              Why do you think you would like to work for Tubbees <span>*</span>
            </label>
            <textarea
              type="text"
              cols="40"
              rows="5"
              onChange={(e) => {
                setAbout(e.target.value);
              }}
            />
            <label>
              Upload your CV on PDF or WORD<span>*</span>
            </label>
            <input
              type="file"
              name="cv"
              required
              accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              onChange={(e) => {
                setCv(e.target.files[0]);
              }}
              className="formInput"
            />
            
            <button disabled={isSending} type="submit">Submit</button>
            <br />
            <h3>{message}</h3>
          </div>
        </section>
        </form>
        <Footer />
      </>
    );
}